module.exports = __webpack_public_path__ + "static/media/play-circle-white-icon.65484c46.svg";